module.exports = __webpack_public_path__ + "static/media/civic.8cba0493.png";